import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const HeritageGallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
  { id: 'all', label: 'All Photos', icon: 'Images' },
  { id: 'vintage', label: 'Vintage', icon: 'Clock' },
  { id: 'craftsmanship', label: 'Craftsmanship', icon: 'Hand' },
  { id: 'community', label: 'Community', icon: 'Users' },
  { id: 'products', label: 'Products', icon: 'Croissant' }];


  const galleryItems = [
  {
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_158eba9d1-1764538642937.png",
    imageAlt: "Sepia-toned vintage photograph from 1985 showing Giuseppe and Maria Montesanto standing proudly in front of their newly opened bakery storefront with hand-painted wooden sign and traditional Italian decor",
    title: "Opening Day - 1985",
    category: "vintage",
    description: "Giuseppe and Maria on the first day of Montesanto Bakery"
  },
  {
    image: "https://images.unsplash.com/photo-1689778560408-78595f912b97",
    imageAlt: "Close-up of experienced baker's weathered hands expertly kneading traditional Italian bread dough on flour-covered marble surface, showing decades of practiced technique and artisan craftsmanship",
    title: "Master Craftsmanship",
    category: "craftsmanship",
    description: "40 years of perfecting traditional techniques"
  },
  {
    image: "https://images.unsplash.com/photo-1730301256512-302b741a94ca",
    imageAlt: "Warm community gathering scene with diverse group of smiling neighbors and regular customers enjoying fresh pastries and coffee together at bakery tables during morning rush hour",
    title: "Community Gathering",
    category: "community",
    description: "Our bakery has always been a neighborhood meeting place"
  },
  {
    image: "https://images.unsplash.com/photo-1587063769105-6558b46acc44",
    imageAlt: "Artistic overhead shot of freshly baked golden Italian cornetti pastries arranged in perfect rows on professional baking sheet, showing flaky layered texture and artisan quality",
    title: "Signature Cornetti",
    category: "products",
    description: "Made fresh every morning since 1985"
  },
  {
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bcd8bbb4-1764538652126.png",
    imageAlt: "Nostalgic black and white photograph from 1990s showing original bakery interior with vintage display cases, traditional Italian decor, and customers lined up at wooden counter",
    title: "Original Interior - 1992",
    category: "vintage",
    description: "The bakery before our 2015 renovation"
  },
  {
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b5e855e-1764538652013.png",
    imageAlt: "Professional baker carefully scoring traditional Italian bread loaves with sharp blade, showing precise technique and attention to detail in artisan bread making process",
    title: "Traditional Scoring",
    category: "craftsmanship",
    description: "Each loaf is scored by hand using traditional patterns"
  },
  {
    image: "https://images.unsplash.com/photo-1662496164199-771be53d0a22",
    imageAlt: "Heartwarming scene of bakery staff presenting custom birthday cake to delighted young child surrounded by family members, capturing special celebration moment in community bakery",
    title: "Birthday Celebrations",
    category: "community",
    description: "Celebrating life's special moments together"
  },
  {
    image: "https://images.unsplash.com/photo-1733210438201-bb62867cc87c",
    imageAlt: "Elegant display of traditional Italian panettone Christmas breads with golden domed tops studded with candied fruits, wrapped in festive paper and arranged on rustic wooden shelves",
    title: "Holiday Panettone",
    category: "products",
    description: "Our famous Christmas tradition"
  },
  {
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1769ba98d-1764538643972.png",
    imageAlt: "Vintage family photograph showing three generations of Montesanto family members in baker's uniforms standing together in bakery, representing 40-year family legacy and tradition",
    title: "Three Generations",
    category: "vintage",
    description: "The Montesanto family through the decades"
  },
  {
    image: "https://images.unsplash.com/photo-1717423209097-180d7b789576",
    imageAlt: "Detailed close-up of baker's hands delicately piping fresh cream filling into golden baked Italian pastry using professional pastry bag, showing precision and artisan skill",
    title: "Pastry Artistry",
    category: "craftsmanship",
    description: "Every pastry is filled with care and precision"
  },
  {
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_177ac99c3-1764538651524.png",
    imageAlt: "Joyful community event photo showing bakery hosting Italian baking workshop with diverse group of participants learning traditional techniques, flour flying and everyone smiling",
    title: "Baking Workshops",
    category: "community",
    description: "Teaching Italian traditions to new generations"
  },
  {
    image: "https://images.unsplash.com/photo-1714667533821-f19187cd8fc3",
    imageAlt: "Rustic display of traditional Italian focaccia bread with characteristic dimpled surface glistening with olive oil and topped with fresh rosemary, photographed on wooden cutting board",
    title: "Focaccia Genovese",
    category: "products",
    description: "Traditional Ligurian recipe from our family"
  }];


  const filteredItems = selectedCategory === 'all' ?
  galleryItems :
  galleryItems?.filter((item) => item?.category === selectedCategory);

  return (
    <section className="py-20 bg-card">
      <div className="container-custom">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-4">
            <Icon name="Camera" size={18} color="var(--color-primary)" />
            <span className="text-sm font-medium text-primary">Visual Heritage</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-foreground mb-4">
            40 Years in Pictures
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            A photographic journey through four decades of Italian baking tradition, community connection, and family legacy
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories?.map((category) =>
          <button
            key={category?.id}
            onClick={() => setSelectedCategory(category?.id)}
            className={`px-6 py-3 rounded-xl text-sm font-medium transition-all duration-300 flex items-center gap-2 ${
            selectedCategory === category?.id ?
            'bg-primary text-primary-foreground shadow-warm' :
            'bg-background text-foreground hover:bg-muted'}`
            }>

              <Icon
              name={category?.icon}
              size={18}
              color={selectedCategory === category?.id ? 'var(--color-primary-foreground)' : 'var(--color-foreground)'} />

              {category?.label}
            </button>
          )}
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredItems?.map((item, index) =>
          <div
            key={index}
            className="group relative bg-background rounded-xl overflow-hidden shadow-warm hover:shadow-warm-lg transition-all duration-300">

              <div className="relative aspect-[4/3] overflow-hidden">
                <Image
                src={item?.image}
                alt={item?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                
                <div className="absolute inset-0 flex items-end p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="text-white">
                    <h3 className="font-serif text-xl font-bold mb-2">
                      {item?.title}
                    </h3>
                    <p className="text-sm text-white/90">
                      {item?.description}
                    </p>
                  </div>
                </div>

                <div className="absolute top-4 right-4">
                  <div className="w-10 h-10 rounded-full bg-background/90 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <Icon name="ZoomIn" size={20} color="var(--color-primary)" />
                  </div>
                </div>
              </div>

              <div className="p-4 lg:hidden">
                <h3 className="font-serif text-lg font-semibold text-foreground mb-1">
                  {item?.title}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {item?.description}
                </p>
              </div>
            </div>
          )}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex flex-col items-center gap-4 px-8 py-6 rounded-2xl bg-gradient-to-br from-primary/10 via-accent/10 to-primary/10 border border-primary/20">
            <Icon name="Instagram" size={48} color="var(--color-primary)" />
            <div>
              <h4 className="font-serif text-2xl font-bold text-foreground mb-2">
                Follow Our Daily Story
              </h4>
              <p className="text-muted-foreground mb-4">
                See fresh creations, behind-the-scenes moments, and customer celebrations on Instagram
              </p>
              <div className="flex items-center justify-center gap-2 text-primary font-medium">
                <span>@montesantobakery</span>
                <Icon name="ExternalLink" size={16} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeritageGallery;